module.exports = __webpack_public_path__ + "static/media/nl.597dd0a6.svg";